<section class="nd-dialog" role="dialog" aria-labelledby="ndDialogTitle">

  <header class="nd-dialog__header">
    <div class="nd-dialog__icon" [attr.data-type]="data.notification.notificationType">
      <i class="fas" [ngClass]="data.iconClass"></i>
    </div>
    <div class="nd-dialog__head-meta">
      <div class="nd-dialog__head-row">
        <span class="nd-dialog__status"
          [class.nd-dialog__status--read]="data.notification.status === 'READ'"
          [class.nd-dialog__status--unread]="data.notification.status === 'UNREAD'">
          <i class="fas"
            [ngClass]="data.notification.status === 'READ' ? 'fa-check-circle' : 'fa-circle'"></i>
          {{ data.notification.status === 'READ' ? 'Leída' : 'No leída' }}
        </span>
      </div>
      <time class="nd-dialog__time" [attr.datetime]="data.notification.createdAt">
        {{ data.formattedDate }}
      </time>
    </div>
    <button type="button" class="nd-dialog__close" (click)="close()" aria-label="Cerrar">
      <i class="fas fa-times"></i>
    </button>
  </header>

  <div class="nd-dialog__body">
    <h2 id="ndDialogTitle" class="nd-dialog__title">{{ data.notification.title }}</h2>
    <p class="nd-dialog__text">{{ data.notification.body }}</p>
  </div>

  <footer class="nd-dialog__footer">
    <button type="button" class="nd-dialog__btn nd-dialog__btn--ghost" (click)="close()">
      Cerrar
    </button>
    <button *ngIf="canNavigate()" type="button" class="nd-dialog__btn nd-dialog__btn--primary"
      (click)="navigate()">
      <i class="fas fa-external-link-alt"></i>
      <span>Abrir</span>
    </button>
    <button type="button" class="nd-dialog__btn nd-dialog__btn--danger"
      (click)="delete()" [disabled]="deleting">
      <i class="fas" [ngClass]="deleting ? 'fa-spinner fa-spin' : 'fa-trash-alt'"></i>
      <span>{{ deleting ? 'Eliminando…' : 'Eliminar' }}</span>
    </button>
  </footer>
</section>
